import React from 'react'

import { Hero } from "../components/home/Hero";
import { Projects } from "../components/home/Projects";
import { Skills } from "../components/home/Skills";
import { useFetch } from "../hooks/useFetch";
import { DATA_BASE_URL } from "../config";

export const HomePage = () => {
  const { data } = useFetch(`${DATA_BASE_URL}/home.json`);
  const { skills = [], projects = [] } = data ?? {};

  return (
    <div>
        <Hero />
        <Skills skills={skills} />
        <Projects projects={projects} />
    </div>
  )
}
